import { render, staticRenderFns } from "./ks-about-us.vue?vue&type=template&id=d7baa26e"
var script = {}
import style0 from "./ks-about-us.vue?vue&type=style&index=0&id=d7baa26e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports